import * as React from "react";
import { DefaultButton, Icon, IconButton, PrimaryButton } from "office-ui-fabric-react";
import { withRouter } from "react-router-dom";

export interface ISidebarLinkProps {
  description: string;
  title: string;
  iconName: string;
  path: string;
  color?: string;
  fullWidth?: boolean;
  history: any;
}
const jwtDecode = require("jwt-decode");
class SideBarLink extends React.Component<ISidebarLinkProps> {
  onButtonClicked() {
    if (this.props.path == "home") {
      const thetoken = jwtDecode(localStorage.getItem("id_token"));
      window.location.href = thetoken.url;
    } else {
      this.props.history.push(this.props.path);
    }
  }

  render() {
    const containerClass = `ms-Grid-col ${
      this.props.fullWidth ? "ms-sm12" : "ms-sm6"
    } ms-font-xxl sidebar-view-item`;
    const buttonStyle = {
      backgroundColor: this.props.color ? this.props.color : '#1d4f90',
    };

    return (
      <div>
        <div className={containerClass}>
            <PrimaryButton 
            className="sidenav-buttons"
              styles={{root:{backgroundColor: this.props.color ? this.props.color : '#1d4f90', marginRight: "0px", borderRadius: '8px'}}}
              title={this.props.description}
              onClick={this.onButtonClicked.bind(this)}>

              <div className="ms-Grid">
                <div className="ms-Grid-row">
                      <Icon iconName={this.props.iconName} aria-hidden="true" style={{fontSize: '20px'}}></Icon>
                </div>
                <div className="ms-Grid-row" style={{ marginTop: "2px" }}>
                      <span className="ms-Button-label">{this.props.title}</span>
                </div>

              </div>
            </PrimaryButton>



           {/* <IconButton
            iconProps={{ iconName: this.props.iconName }}
            style={buttonStyle}
            title={this.props.description}
            onClick={this.onButtonClicked.bind(this)}
          /> */}
        </div>
      </div>
    );
  }
}

export default withRouter(SideBarLink);
